import { render, staticRenderFns } from "./CustomBlocks.vue?vue&type=template&id=2d3b23d7"
import script from "./CustomBlocks.vue?vue&type=script&lang=js"
export * from "./CustomBlocks.vue?vue&type=script&lang=js"
import style0 from "./CustomBlocks.vue?vue&type=style&index=0&id=2d3b23d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports